// World units are pixels in an 800 x 500 scene. The simulation never uses
// trigonometry or Math.pow, so results are identical in every JS engine
// (browser and Cloudflare Worker), which the server relies on to replay runs.

export const TICK_HZ = 120;
export const DT = 1 / TICK_HZ;
export const STEP_MS = 1000 / TICK_HZ;

export const GROUND = 400;
export const FROG_X = 400;
export const HUB_Y = 300;
export const ROPE_R = 100;
export const POSTS = [110, 690] as const;
export const CRANK = 16;
export const HEAD_H = 60; // head height above the frog's feet

// Jump: a tap reaches ~62 px in ~0.46 s; holding reaches ~99 px in ~0.61 s.
export const JUMP_V0 = 540;
export const GRAVITY = 2350;
export const HOLD_GRAVITY_MUL = 0.55;
export const HOLD_MAX_TICKS = 24;

// A press up to 100 ms before landing is kept and fires on landing.
export const BUFFER_TICKS = 12;
export const BUFFER_HEIGHT = 26;

export const TONGUE_TICKS = 18;
export const TONGUE_REACH = 80;
export const MAGNET_REACH = 190;

export const SLOW_TICKS = 600;
export const SLOW_MUL = 0.7;
export const MAGNET_TICKS = 960;
export const STUN_TICKS = 96;

export const MIN_PERIOD = 0.62;
export const MIN_DOUBLE_PERIOD = 1.25;
export const CYCLE_SPEEDUP = 0.9;

export const START_PHASE = 0.03;
export const JUMPS_PER_SCENE = 30;
export const MAX_RUN_TICKS = 2 * 60 * 60 * TICK_HZ;

/** Frog height (px) needed at the moment the rope passes under it. */
export const THRESHOLDS = {
  normal: { ok: 10, good: 26, perfect: 44 },
  ice: { ok: 14, good: 32, perfect: 52 },
} as const;

export const GRADE_POINTS = { perfect: 3, good: 2, ok: 1 } as const;
export const FLY_POINTS = 5;
export const GOLDEN_POINTS = 25;
